export default "__VITE_ASSET__DH$Mk3za__"